// Per-hostname branding for everything that lives outside the React tree:
// the tab title, favicon, home-screen icon, PWA manifest and the icons on
// browser notifications. The in-page logo is handled by DynamicLogo.
//
// The public/ folder holds one build that serves both brands, so every asset
// named here must exist there for both of them.

const PHONEPLAY = {
  name: "Phone Play",
  description: "PhonePlay - Mobile Recharge & Bill Payment Platform",
  favicon: "/black-logo.png",
  appleTouchIcon: "/logo192.png",
  manifest: "/manifest.json",
  notificationIcon: "/white-logo.png",
  notificationBadge: "/logo192.png",
};

const CELLTOP = {
  name: "Cell Top",
  description: "CellTop - Mobile Recharge & Bill Payment Platform",
  favicon: "/celltop-logo192.png",
  appleTouchIcon: "/celltop-logo192.png",
  manifest: "/manifest-celltop.json",
  notificationIcon: "/celltop-logo192.png",
  notificationBadge: "/celltop-logo192.png",
};

const BRAND_BY_HOST = {
  "phoneplay.me": PHONEPLAY,
  "www.phoneplay.me": PHONEPLAY,
  "celltop.vip": CELLTOP,
  "www.celltop.vip": CELLTOP,
};

export const getBrand = (hostname = window.location.hostname) =>
  BRAND_BY_HOST[hostname] || PHONEPLAY;

export default getBrand;
